import ShaddowPuppets from "./ShadowPuppets";
import { useEffect, useState } from "react";

export default function Level3_ShadowPuppets(props) {
  const Level1 = ["Dog", "Butterfly"];

  
    return (
      <ShaddowPuppets {...props} level={Level1} levelLabel="Level1" defaultImage="Dog" />
    );
  }
  
